import { render } from "./jabfung.vue?vue&type=template&id=63c7f364"
import script from "./jabfung.vue?vue&type=script&lang=js"
export * from "./jabfung.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__